import { Box, SxProps, Theme } from "@mui/material";
import { isNil } from "lodash-es";

import { NumberHelper } from "@/common/helpers/number";

interface Props {
  value?: number | null;
  sx?: SxProps<Theme>;
}

/** Displays percent value normalized to [0;100]. */
export default function PercentValue({ value, sx }: Props) {
  if (isNil(value)) {
    return null;
  }

  return (
    <Box component='span' sx={sx}>
      {NumberHelper.normalizePercentToZeroHundred(value)}%
    </Box>
  );
}
